import { useTranslation } from '@crehana/i18n';

import locales, { CANDIDATE_FORM, type TKeys } from '../i18n';

export const useAddResourceBundle = () => {
  const { addResourceBundle } = useTranslation<TKeys>(CANDIDATE_FORM);

  addResourceBundle(locales);
};
